export default "__VITE_ASSET__b9116031__"